// extracted by mini-css-extract-plugin
export default {"wrapper":"FormatPage_wrapper__ROFS8","form":"FormatPage_form__hxu9J","globalErrors":"FormatPage_globalErrors__6txLM"};